export function forEachObj(obj, fn) {

	for (let key in obj) {

		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			fn(key, obj[key], obj);
		}

	}

}

export function mapObj(obj, fn) {

	const result = {};

	forEachObj(obj, (key, value, obj) => {
		result[key] = fn(key, value, obj);
	});

	return result;

}

export function filterObj(obj, fn) {

	const result = {};

	forEachObj(obj, (key, value, obj) => {
		const keep = fn(key, value, obj);
		if (keep) {
			result[key] = value;
		}
	});

	return result;

}

export function mapObjToArr(obj, fn) {

	const result = [];

	forEachObj(obj, (key, value, obj) => {
		result.push(fn(key, value, obj));
	});

	return result;

}



// WEBPACK FOOTER //
// ./utils/object-helpers.js